/**
 * Copyright (c) 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule cloneWithProps
 */

module.exports = require('react/lib/cloneWithProps');



/*****************
 ** WEBPACK FOOTER
 ** ./~/fixed-data-table/internal/cloneWithProps.js
 ** module id = 533
 ** module chunks = 0
 **/